import {createGlobalStyle} from 'styled-components'
import globalStyles from './global.styles'

const GlobalStylesAtom = createGlobalStyle`
  ${globalStyles}
`

export default GlobalStylesAtom
